export interface AuthState {
  isAuthenticated: boolean;
  token: string | null;
  roles: string[];
  loading: boolean;
  error: string | null;
}

export const initialAuthState: AuthState = {
  isAuthenticated: false,
  token: null,
  roles: [],
  loading: false,
  error: null,
};
